import { Button, IconButton } from '@mui/material';
import { type ButtonProps } from '@react-awesome-query-builder/mui';

import Icon from '../../Icon';

export default function MaterialButton({ type, label, onClick }: ButtonProps) {
	const typeToOnlyIcon = {
		addRuleGroup: <Icon icon="add" />,
		addRuleGroupExt: <Icon icon="add" />,
		delRuleGroup: <Icon icon="delete" />,
		delRule: <Icon icon="delete" />
	};

	const typeToIcon = {
		addRule: <Icon icon="add" size={18} />,
		addGroup: <Icon icon="add" size={18} />,
		delGroup: <Icon icon="delete" size={18} />
	};

	const typeToColor = {
		// addRule: 'primary',
		// addGroup: 'primary',
		// delGroup: 'error',
		// delRuleGroup: 'error',
		// delRule: 'error'
	};

	if (typeToOnlyIcon[type])
		return (
			<IconButton size="small" onClick={onClick} color={typeToColor[type]}>
				{typeToOnlyIcon[type]}
			</IconButton>
		);

	return (
		<Button size="small" onClick={onClick} color={typeToColor[type]} startIcon={typeToIcon[type]}>
			{label}
		</Button>
	);
}
